/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NTPServerPartialUpdate
 */
export interface NTPServerPartialUpdate {
    /**
     * 
     * @type {string}
     * @memberof NTPServerPartialUpdate
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof NTPServerPartialUpdate
     */
    options?: string;
}

export function NTPServerPartialUpdateFromJSON(json: any): NTPServerPartialUpdate {
    return NTPServerPartialUpdateFromJSONTyped(json, false);
}

export function NTPServerPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): NTPServerPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': !exists(json, 'address') ? undefined : json['address'],
        'options': !exists(json, 'options') ? undefined : json['options'],
    };
}

export function NTPServerPartialUpdateToJSON(value?: NTPServerPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'options': value.options,
    };
}


